package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class CreateNoteRequest(val body: String)
